module.exports = __webpack_public_path__ + "static/img/18.4071a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/18.png
// module id = /o6z
// module chunks = 1